import React from 'react';

const PaintingModeSelector = ({ 
  paintingStyle, 
  artStyle, 
  onPaintingStyleChange, 
  onArtStyleChange, 
  language 
}) => {
  const paintingStyles = [
    { id: 'watercolor', name: language === 'KR' ? '수채화' : 'Watercolor' },
    { id: 'oil', name: language === 'KR' ? '유화' : 'Oil Painting' },
    { id: 'acrylic', name: language === 'KR' ? '아크릴화' : 'Acrylic Painting' },
    { id: 'pen', name: language === 'KR' ? '펜화' : 'Pen Drawing' },
    { id: 'pencil', name: language === 'KR' ? '연필화' : 'Pencil Drawing' },
    { id: 'pastel', name: language === 'KR' ? '파스텔화' : 'Pastel Drawing' }
  ];

  const artStyles = [
    { id: 'realism', name: language === 'KR' ? '사실주의' : 'Realism' },
    { id: 'impressionism', name: language === 'KR' ? '인상주의' : 'Impressionism' },
    { id: 'postimpressionism', name: language === 'KR' ? '후기 인상주의' : 'Post-Impressionism' },
    { id: 'expressionism', name: language === 'KR' ? '표현주의' : 'Expressionism' },
    { id: 'cubism', name: language === 'KR' ? '입체주의' : 'Cubism' },
    { id: 'abstract', name: language === 'KR' ? '추상주의' : 'Abstract' },
    { id: 'surrealism', name: language === 'KR' ? '초현실주의' : 'Surrealism' },
    { id: 'popart', name: language === 'KR' ? '팝 아트' : 'Pop Art' },
    { id: 'minimalism', name: language === 'KR' ? '미니멀리즘' : 'Minimalism' },
    { id: 'baroque', name: language === 'KR' ? '바로크' : 'Baroque' },
    { id: 'rococo', name: language === 'KR' ? '로코코' : 'Rococo' },
    { id: 'romanticism', name: language === 'KR' ? '낭만주의' : 'Romanticism' },
    { id: 'classicism', name: language === 'KR' ? '고전주의' : 'Classicism' },
    { id: 'fauvism', name: language === 'KR' ? '야수파' : 'Fauvism' },
    { id: 'pointillism', name: language === 'KR' ? '점묘법' : 'Pointillism' },
    { id: 'inkwash', name: language === 'KR' ? '수묵화' : 'Ink Wash Painting' },
    { id: 'oriental_bird', name: language === 'KR' ? '화조화' : 'Oriental Bird & flower' },
    { id: 'oriental_landscape', name: language === 'KR' ? '산수화' : 'Oriental Landscape' }
  ];

  return (
    <div className="painting-mode-selector">
      <div className="painting-style-section">
        <label htmlFor="painting-style" className="painting-label">
          {language === 'KR' ? '표현 방식:' : 'Painting Style:'}
        </label>
        <select
          id="painting-style"
          value={paintingStyle}
          onChange={(e) => onPaintingStyleChange(e.target.value)}
          className="painting-dropdown"
        >
          {paintingStyles.map((style) => (
            <option key={style.id} value={style.id}>
              {style.name}
            </option>
          ))}
        </select>
      </div>

      <div className="art-style-section">
        <label htmlFor="art-style" className="painting-label">
          {language === 'KR' ? '화풍:' : 'Art Style:'}
        </label>
        <select
          id="art-style"
          value={artStyle}
          onChange={(e) => onArtStyleChange(e.target.value)}
          className="painting-dropdown"
        >
          {artStyles.map((style) => (
            <option key={style.id} value={style.id}>
              {style.name}
            </option>
          ))}
        </select>
      </div>
    </div>
  );
};

export default PaintingModeSelector;